// src/App.jsx
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./hooks/useAuth";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import PublicPage from "./pages/PublicPage";

function PrivateRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <div style={loadingStyle}>로딩 중...</div>;
  return user ? children : <Navigate to="/login" replace />;
}

function RootRoute() {
  const { user } = useAuth();
  if (user === undefined) return <div style={loadingStyle}>로딩 중...</div>;
  return user ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRoute />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          {/* Public slug page - must be last */}
          <Route path="/:slug" element={<PublicPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

const loadingStyle = {
  minHeight: "100vh",
  background: "#f1f3f7ef",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#8b949e",
  fontFamily: "'Pretendard', 'Noto Sans KR', sans-serif",
  fontSize: "14px",
};
